import React from 'react';
import LabelValueDisplay, { LabelValueItem } from '../../../v2BaseComponents/LabelValueDisplay';
import { getIntl } from '../../../../utils/intl';
import { APITypes } from '../../../../primary-record-types';
import getName from '../../../../utils/getName';
import { organizationRoles } from '../../../../utils/sharedMessages';

const intl = getIntl('OrganizationInvitationDetails', {
    name: 'Invitee Name',
    email: 'Invitee Email',
    role: 'Role',
    message: 'Message',
});

export type OrganizationInvitationDetailsOwnProps = {
    invitation: APITypes.organizationService.GetOrganizationUserInvitationResponse;
};

export type OrganizationInvitationDetailsProps = OrganizationInvitationDetailsOwnProps;

const OrganizationInvitationDetails: React.FC<OrganizationInvitationDetailsProps> = ({ invitation }) => {
    const getLabelValueItems = (
        invitation: APITypes.organizationService.GetOrganizationUserInvitationResponse,
    ): LabelValueItem[] => {
        return [
            {
                label: intl('name'),
                value: getName({
                    firstName: invitation.inviteeFirstName,
                    lastName: invitation.inviteeLastName,
                }),
            },
            {
                label: intl('email'),
                value: invitation.inviteeEmail,
            },
            {
                label: intl('role'),
                value: organizationRoles(invitation.inviteeRole),
            },
            {
                label: intl('message'),
                value: invitation.message,
            },
        ];
    };

    return <LabelValueDisplay omitEmptyValues items={getLabelValueItems(invitation)} />;
};

export default React.memo(OrganizationInvitationDetails);
